// Mock data for Full Body Faja Colombiana Landing Page

export const productData = {
  id: "full-body-faja",
  name: "Full Body Faja Colombiana",
  tagline: "Snatched. Sculpted. Confident — Instantly.",
  price: 41.99,
  originalPrice: 55.99,
  currency: "USD",
  images: [
    "https://customer-assets.emergentagent.com/job_item-landing/artifacts/xi9fvl5g_Untitled%2011.gif",
    "https://cdn.shopify.com/s/files/1/1010/9278/6544/files/After_759dd8b9-2552-456d-baac-0638f5558b4e.png?v=1775771901",
    "https://cdn.shopify.com/s/files/1/1010/9278/6544/files/faja_side_1.jpg?v=1775771216",
    "https://cdn.shopify.com/s/files/1/1010/9278/6544/files/faja_detailed_view_1.jpg?v=1775771216",
    "https://cdn.shopify.com/s/files/1/1010/9278/6544/files/openart-fb5030083b9e443cb76e15c26185160a_raw_1_1.jpg?v=1775771216",
    "https://cdn.shopify.com/s/files/1/1010/9278/6544/files/openart-c6cc881de99341e6b2c574149c0e3e66_raw.jpg?v=1775861940",
    "https://cdn.shopify.com/s/files/1/1010/9278/6544/files/Beige_fajas_back_view.jpg?v=1775861902",
    "https://cdn.shopify.com/s/files/1/1010/9278/6544/files/Beige_fajas.png?v=1775862388"
  ],
  imagesByColor: {
    Black: [
      "https://customer-assets.emergentagent.com/job_item-landing/artifacts/ymvx3tpt_openart-14c4bd9b-a791-48cc-996b-d64c115a23b4.png",
      "https://cdn.shopify.com/s/files/1/1010/9278/6544/files/faja_detailed_view_1.jpg?v=1775771216",
      "https://customer-assets.emergentagent.com/job_item-landing/artifacts/sp7b0sng_Picture22.jpg",
      "https://customer-assets.emergentagent.com/job_item-landing/artifacts/lpvi7d4u_Carmen%20on%20landing%20Amalfi.jpg",
      "https://customer-assets.emergentagent.com/job_item-landing/artifacts/02ptojhv_Hook%20and%20eye.jpeg",
      "https://customer-assets.emergentagent.com/job_item-landing/artifacts/hscverqu_Zipper%20crotch.jpg",
      "https://customer-assets.emergentagent.com/job_item-landing/artifacts/ti15dprt_Close%20up%20beige.jpg"
    ],
    Nude: [
      "https://cdn.shopify.com/s/files/1/1010/9278/6544/files/openart-image_c5auW15Z_1775869447184_raw.jpg?v=1775871563",
      "https://cdn.shopify.com/s/files/1/1010/9278/6544/files/openart-image_YxE2rkrk_1775871186707_raw.jpg?v=1775871564",
      "https://cdn.shopify.com/s/files/1/1010/9278/6544/files/openart-image_35VnipLQ_1775870771645_raw.jpg?v=1775871562",
      "https://cdn.shopify.com/s/files/1/1010/9278/6544/files/Close_up_beige.jpg?v=1775871560",
      "https://customer-assets.emergentagent.com/job_item-landing/artifacts/02ptojhv_Hook%20and%20eye.jpeg",
      "https://customer-assets.emergentagent.com/job_item-landing/artifacts/hscverqu_Zipper%20crotch.jpg",
      "https://customer-assets.emergentagent.com/job_item-landing/artifacts/ti15dprt_Close%20up%20beige.jpg"
    ]
  },
  mainImage: "https://customer-assets.emergentagent.com/job_item-landing/artifacts/xi9fvl5g_Untitled%2011.gif",
  description: `This is a Faja Colombianas. Medical-grade compression sculpts your waist instantly.

Zipper crotch means all-day wear without bathroom struggles. Hook-and-eye front closure for adjustable compression. Butt lifter panels that enhance, don't flatten.`,
  colors: ["Black", "Nude"],
  sizes: ["S", "M", "L", "XL", "2XL", "3XL"],
  features: [
    {
      icon: "Sparkles",
      title: "Medical-Grade Compression",
      description: "Authentic Faja Colombiana construction. Instantly cinches your waist 2–3 inches and sculpts your silhouette the moment you put it on."
    },
    {
      icon: "Heart",
      title: "Zipper Crotch",
      description: "Bathroom access in seconds — no undressing, no struggle. Designed for all-day wear from morning coffee to midnight cocktails."
    },
    {
      icon: "Shield",
      title: "Hook-and-Eye Closure",
      description: "Three rows of front hooks let YOU control the compression. Tighten as you lose inches over time — your faja grows with you."
    },
    {
      icon: "Star",
      title: "Butt Lifter Panels",
      description: "Specially engineered panels that enhance and lift your curves. Built-in bra means no separate undergarments needed."
    }
  ],
  benefits: [
    "Snatched waist instantly",
    "Medical-grade compression",
    "Zipper crotch convenience",
    "Hook-and-eye adjustable fit",
    "Built-in bra + butt lifter",
    "Invisible under any outfit"
  ],
  testimonials: [
    {
      name: "Sarah M.",
      location: "Los Angeles, CA",
      rating: 5,
      text: "I used to HATE getting dressed for events. Nothing fit right and I'd cancel plans last minute. This bodysuit changed my life! I wore it to a wedding last week and got SO many compliments. For the first time in years, I felt beautiful.",
      verified: true
    },
    {
      name: "Jennifer K.",
      location: "New York, NY",
      rating: 5,
      text: "After having two kids, my body changed completely. This faja is a game changer! The compression is no joke — instant waist cinching the moment I put it on. I can breathe, move, and I look AMAZING. Now I'm wearing every dress in my closet again!",
      verified: true
    },
    {
      name: "Michelle R.",
      location: "Miami, FL",
      rating: 5,
      text: "I was so self-conscious about my muffin top — couldn't wear half my wardrobe. Now I reach for this bodysuit every single day. My husband even noticed I'm more confident. It's not just shapewear, it's a confidence boost in fabric form!",
      verified: true
    }
  ],
  faqs: [
    {
      question: "What sizes are available?",
      answer: "Our Faja Colombiana is available in sizes S through 3XL. Please refer to our size chart: S (US 2-4), M (US 6-8), L (US 10-12), XL (US 14-16), 2XL (US 18-20), 3XL (US 22-24). For best fit, measure your bust, waist, and hips and compare to our size guide. If between sizes, size up for comfort or down for maximum compression."
    },
    {
      question: "How do I care for my bodysuit?",
      answer: "Hand wash in cold water with mild detergent and lay flat to dry. This will help maintain the shape and quality of the fabric."
    },
    {
      question: "Is the bodysuit comfortable for all-day wear?",
      answer: "Absolutely! The breathable, stretchy fabric is designed for maximum comfort. Many customers wear it from morning to night without any discomfort."
    },
    {
      question: "What's your return policy?",
      answer: "We offer a 30-Day Satisfaction Guarantee. If you're not completely satisfied, return it for a full refund within 30 days of purchase."
    },
    {
      question: "Where do you ship?",
      answer: "We offer free shipping within the United States (3-5 business days). We also ship to Canada with applicable shipping fees calculated at checkout."
    },
    {
      question: "How long does shipping take?",
      answer: "US orders: Free shipping, typically 3-5 business days. Canadian orders: 7-10 business days with shipping fees applied at checkout."
    },
    {
      question: "Will it show under my clothes?",
      answer: "No! The seamless design and smooth fabric make it completely invisible under clothing — that's the magic of a true Faja Colombiana. Sculpts you under the dress, no one sees a thing."
    }
  ],
  guarantee: {
    title: "30-Day Satisfaction Guarantee",
    description: "Love it or your money back. We're that confident you'll be obsessed with your faja."
  },
  shipping: {
    title: "Free US Shipping",
    description: "Fast, reliable delivery to your door. Canada shipping available."
  }
};
